/** @format */

import { differenceInDays, isValid } from 'date-fns';
import { memoize } from 'lodash';

/**
 * isDateTimeString
 */
export const isDateTimeString = memoize((value) =>
  /((\d{4}(-|\/)\d{2}(-|\/)\d{2})|(\d{2}(-|\/)\d{2}(-|\/)\d{4}))(\s)(\d{2}:\d{2}:\d{2})$/.test(value)
);

/**
 * isDateString
 */
export const isDateString = memoize((value) => /(\d{4}(-|\/)\d{2}(-|\/)\d{2})|(\d{2}(-|\/)\d{2}(-|\/)\d{4})$/.test(value));

/**
 * isIsoDateString
 */
export const isIsoDateString = memoize((value) =>
  // ?(.\d{3}Z)
  /\d{4}(-|\/)\d{2}-\d{2}T\d{2}:\d{2}:\d{2}((\+\d{2}:\d{2})|(.\d{3}Z))?/.test(value)
);
export const isDateStringIso = (value) => {
  let isValidDate = false;
  if (value) {
    const parsedDate = new Date(value);
    isValidDate = !isNaN(parsedDate.getTime());
  }

  return isValidDate;
};
/**
 * isDate
 * @param value
 * @returns
 */
export const isDate = (value) => {
  return isValid(value) || isDateStringIso(value) || isDateString(value) || isDateTimeString(value);
};

/**
 * countDays
 * @param {*} start
 * @param {*} end
 * @returns
 */
export const countDays = (start, end) => {
  const isStartDate = isDate(new Date(start));

  const isEndDate = isDate(new Date(end));

  if (isStartDate && isEndDate) {
    const diff = differenceInDays(new Date(end), new Date(start));
    return diff + 1;
  }

  if (isStartDate || isEndDate) {
    return 1;
  }

  return 0;
};

/**
 * paseDate
 * @param {*} value
 * @returns
 */
export const paseDate = (value) => {
  let isValidDate = false;
  let parsedDate = value;
  if (value) {
    parsedDate = new Date(value);

    isValidDate = !isNaN(parsedDate.getTime());
    console.log('paseDate', parsedDate, isValidDate);
  }

  return isValidDate ? parsedDate : value;
};
